/**
 * Nafath Status Enum
 * Used for Nafath verification status
 */
export enum NafathStatusEnums {
  WAITING = 'waiting',
  EXPIRED = 'expired',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  DEPRECATED = 'deprecated',
}
